import { apiFetch } from "@hp/api-client";
import * as api from "@hp/api-client";
import type { ListFindingsParams, ListFindingsResponse } from "@hp/api-client";
import type { Finding } from "@hp/types";
import type { AppealChain } from "./types";

/**
 * Lists Findings for the tabular/columnar review view: pick a set of
 * comparable orders (filtered by issue tag/forum/search) and pull one
 * field out of each into a spreadsheet-style grid.
 */
export async function listFindings(params: ListFindingsParams = {}): Promise<ListFindingsResponse> {
  return api.listFindings(params);
}

/** Fetch one Finding by id. Wrap in `useQuery` with a queryKey of `["findings", id]`. */
export async function getFinding(id: string, signal?: AbortSignal): Promise<Finding> {
  return apiFetch<Finding>(`/findings/${encodeURIComponent(id)}`, { method: "GET", signal });
}

/**
 * Resolve a Finding's own appeal-chain: every Finding connected to it by a
 * same-matter CitationEdge (as opposed to a "cites" ratio citation),
 * ordered chronologically, with the edge type describing what each step
 * did to the one before it. Wrap in `useQuery` with a queryKey of
 * `["findings", findingId, "appeal-chain"]`.
 */
export async function getAppealChain(findingId: string, signal?: AbortSignal): Promise<AppealChain> {
  return apiFetch<AppealChain>(`/findings/${encodeURIComponent(findingId)}/appeal-chain`, {
    method: "GET",
    signal,
  });
}
